import type { TokenUsage } from '@pantheon/shared';

interface UsageBadgeProps {
  usage?: TokenUsage;
  className?: string;
}

function formatTokens(n: number): string {
  if (n < 1000) return String(n);
  if (n < 1000000) return `${(n / 1000).toFixed(1)}K`;
  return `${(n / 1000000).toFixed(2)}M`;
}

export function UsageBadge({ usage, className = '' }: UsageBadgeProps) {
  if (!usage || usage.totalTokens === 0) return null;

  return (
    <div className={`flex items-center gap-3 text-xs text-gray-500 bg-gray-50 rounded-full px-3 py-1.5 ${className}`}>
      <span title="Input tokens">{formatTokens(usage.inputTokens)} in</span>
      <span title="Output tokens">{formatTokens(usage.outputTokens)} out</span>
      <span title="Total tokens" className="font-medium text-gray-500">{formatTokens(usage.totalTokens)} total</span>
      <span title="Estimated cost" className="font-medium text-green-600">${usage.estimatedCost.toFixed(4)}</span>
    </div>
  );
}
